// components
import Label from './label'

// styles
import fieldStyles from '../field.module.scss'

// types
import { BaseFieldProps } from '../field'

export type OptionProps = {
	readonly text: string
} & React.OptionHTMLAttributes<HTMLOptionElement>

export type SelectProps = {
	readonly type: 'select'
	readonly options: OptionProps[]
} & BaseFieldProps &
	React.SelectHTMLAttributes<HTMLSelectElement>

const Text = (props: SelectProps): JSX.Element => {
	const { label, options, type, ...attr } = props
	return (
		<>
			<label>
				<Label label={label} required={attr.required} />
				<div className={fieldStyles.select}>
					<select {...attr}>
						{options.map((option, index) => {
							const { text, value, ...attr } = option
							return (
								<option {...attr} key={index} value={value}>
									{text}
								</option>
							)
						})}
					</select>
				</div>
			</label>
		</>
	)
}

export default Text
